import { exists } from '@/api'
import { dateToPlainFormat } from '@/utils'

export interface UserCardLost {
  uno: string
  count: number
  lost: string
  reissue: string
}

export function UserCardLostFromJSON(json: any): UserCardLost {
  if (json === undefined || json === null) {
    return json
  }
  return {
    uno: exists(json, 'uno') ? json.uno : '',
    count: exists(json, 'count') ? json.count : 0,
    lost: exists(json, 'lost') ? dateToPlainFormat(json.lost) : '',
    reissue: exists(json, 'reissue') ? dateToPlainFormat(json.reissue) : ''
  }
}

export const defaultUserCardLost = (): UserCardLost => ({
  uno: '',
  count: 0,
  lost: '',
  reissue: ''
})
